module.exports = __webpack_public_path__ + "static/media/IconTemplates_-09.7807f650.svg";